import { PRINTING_TYPES } from "/cdn/shop/t/98/assets/printingOptions.constant.js?cash48";

export default {
    props: [
        "activeTab",
        "isLast",
        "isActive",
        "isCompleted",
        "name",
        "tab",
    ],
    emits: [
        "selectTab"
    ],
    data() {
        return {
            printingTypes: PRINTING_TYPES,
            isOpened: false,
        };
    },
    methods: {
        toggle() {
            this.$emit("selectTab", this.tab?.name);

            if (!this.tab?.name) return;

            this.isOpened = !this.isOpened;
        },
    },
    template: `
        <div class="custom-tab-wrapper" :class="{ 'last': isLast }">
            <div class="custom-tab-container">
                <div @click="toggle" 
                    class="custom-tab-container-toggle"
                    :class="{
                        'custom-tab-container-toggle-active': (tab?.name && (tab?.name === activeTab)) || isActive,
                        'custom-tab-container-toggle-completed': tab?.isCompleted || isCompleted,
                    }">
                    <img v-if="tab?.isCompleted || isCompleted" src="/cdn/shop/t/98/assets/check-white.svg" alt="check" />
                    <img v-else-if=" (tab?.name && (tab?.name === activeTab)) || isActive" src="/cdn/shop/t/98/assets/cube.svg" alt="cube" />
                </div>

                <span>{{ name || printingTypes[tab?.name] }}</span>
            </div>


            <div v-if="!isLast" class="custom-tab-separate-line"></div>
        </div>
    `,
};
